import { Empty, Flex } from 'antd'
import React, { ReactNode } from 'react'

export interface ChartEmptyPlaceholderProps {
  description?: ReactNode
}

export default function ChartEmptyPlaceholder({ description }: ChartEmptyPlaceholderProps) {
  return (
    <Flex style={{ height: 320 }} align="center" justify="center">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description}></Empty>
    </Flex>
  )
}

